import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalLayoutsComponent } from './portal/portal-layouts/portal-layouts.component'
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { HrmsLayoutsComponent } from './hrms/hrms-layouts/hrms-layouts.component';
import { AdminLayoutsComponent } from './admin/admin-layouts/admin-layouts.component';
import { MdLayoutsComponent } from './md/md-layouts/md-layouts.component';
import { AccountsLayoutsComponent } from './accounts/accounts-layouts/accounts-layouts.component';
import {RouteResolver} from './resolvers/route.resover'
import {ServerDownComponent} from './server-down/server-down.component'
 
// import { NewSigninComponent } from './new-signin/new-signin.component';
import { SigninformComponent } from './signinform/signinform.component';
import { AmcsLayoutComponent } from './acms/amcs-layout/amcs-layout.component';

const routes: Routes = [
  // ************************************SIMRAN CODE START*********************************
  { path : "" , component: PortalLayoutsComponent , loadChildren:() => import('./portal/portal-layouts/portal-layouts.module').then( m => m.PortalLayoutsModule)},
  { path : "solution-admin" , component: AdminLayoutsComponent , loadChildren:() => import('./admin/admin-layouts/admin-layouts.module').then( m => m.AdminLayoutsModule)},
  { path : "md" , component: MdLayoutsComponent , loadChildren:() => import('./md/md-layouts/md-layouts.module').then( m => m.MdLayoutsModule)},
  { path : "hrms" , component: HrmsLayoutsComponent , loadChildren:() => import('./hrms/hrms-layouts/hrms-layouts.module').then( m => m.HrmsLayoutsModule)},
  { path : "accounts" , component: AccountsLayoutsComponent , loadChildren:() => import('./accounts/accounts-layouts/accounts-layouts.module').then( m => m.AccountsLayoutsModule)},
  { path : "acms" , component: AmcsLayoutComponent , loadChildren:() => import('./acms/amcs-layout/acms-layout.module').then( m => m.AcmsLayoutModule)},

  // **************************************SIMRAN CODE END*************************************
   
      {
          "path": "login",
          "component": SigninformComponent
      },
      {
          "path": "old-login",
          "component": SigninComponent
      },
      {
          "path": "register",
          "component": SignupComponent
      },
      {
          "path": "**",
          "redirectTo": "error_404",
          "pathMatch": "full"
      },
      {
        "path": "error",
        "component": ServerDownComponent
    },
      {
        'path' : '' , 'redirectTo': 'index', 'pathMatch': 'full'
      }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers:[RouteResolver]
})
export class AppRoutingModule { }
